import { hasPermission } from '@/hooks/useBackendMenu'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { CompensacaoFeriado, compensacaoFeriados } from 'service/api'
import { toast } from 'sonner'
import FormNovaCompensacaoFeriado from '../forms/NovaCompensacaoFeriado'
import {
    useDigitacaoDataContext,
    useUpdateDigitacaoQueryData,
} from '../pages/useDigitacaoData'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export default function DetalhesCompensacaoFeriado() {
    const { mutate } = compensacaoFeriados.mutations.useSoftDelete()
    const { mutateAsync } = compensacaoFeriados.mutations.useUpdate()
    const navigate = useNavigate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { id } = useParams()
    const {
        context: { data },
    } = useDigitacaoDataContext()

    const compensacao = data.find(
        ({ compensacao }) => compensacao?.id === Number(id),
    )?.compensacao

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()

    if (!compensacao) return null

    const handleExcluir = ({ motivo }: { motivo: string }) => {
        mutate({ ...compensacao, motivo } as any, {
            onSuccess: async () => {
                setQueryData(
                    'COMPENSACAO_FERIADO',
                    {
                        ...compensacao,
                        deletedAt: new Date(),
                    },
                    true,
                )
                toast.success('Compensação excluída com sucesso')
                navigate(-1)
            },
            onError: e => {
                toast.error(e.message)
            },
        })
    }

    const handleSubmit: SubmitHandler<CompensacaoFeriado> = data =>
        mutateAsync(
            {
                ...data,
                dataCompensacao: dayjs(data.dataCompensacao).toDate(),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
            },
            {
                onSuccess: res => {
                    setQueryData('COMPENSACAO_FERIADO', res)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'CompensaçãoDeFeriados'])}
            defaultValues={{ ...compensacao, statusAprovacao: 'APROVADO' }}
            onDelete={
                hasPermission(['update', 'CompensaçãoDeFeriados']) ||
                funcionarioPodeAjustar
                    ? handleExcluir
                    : undefined
            }
            validateOnDelete
            height="auto"
            onSubmit={
                hasPermission(['create', 'CompensaçãoDeFeriados'])
                    ? handleSubmit
                    : undefined
            }
        >
            <Dialog.Title>Detalhes da compensação de feriado</Dialog.Title>
            <Dialog.Content dividers>
                <FormNovaCompensacaoFeriado />
                <Dialog.Content.Footer />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
